import { getRootAppWindow } from "meta/utils/getRootAppWindow";
import { useAppSelector } from "../hooks/useAppSelector";
export const useChartTabsWebEvents = () => {
    const { activeTabKey } = useAppSelector((state) => state.root);
    const rootWindow = getRootAppWindow(window);
    const refreshVerticalTab = (ignoreUnsavedCheck) => {
        rootWindow.frames[activeTabKey].RootCommunicator.refreshActiveChild(ignoreUnsavedCheck);
    };
    return { refreshVerticalTab };
};
